var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "to-cart" },
    [
      _c("ui-button", {
        staticClass: "to-cart__button",
        attrs: {
          text: _vm.text,
          icon: _vm.icon,
          loading: _vm.progress,
          large: _vm.large,
          wide: "",
          disabled: _vm.isDisabled
        },
        on: { click: _vm.handleAdd }
      }),
      _vm._t("default"),
      !_vm.hideNotification && !_vm.skuId && _vm.product.available
        ? _c(
            "ui-notification",
            {
              ref: "notification",
              attrs: { title: "Необходимо выбрать размер" }
            },
            [
              _vm._v(
                "\n    Чтобы заказать товар онлайн с безопасной доставкой курьером или с самовывозом\n  "
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }